import { Tooltip } from '@mui/material';
import type { ReactElement } from 'react';

/**
 * What a key figure in a side panel means, on hover and on keyboard focus
 * (2026-10-12, the pilot's ask: nobody read the small help lines under the
 * figures). Opens above the figure (the theme's default): to the left it
 * covered the neighbouring figure, which is the one people compare against.
 *
 * The child must take a ref and be focusable — give the figure's box
 * `tabIndex={0}` — so the explanation is reachable without a mouse.
 */
export const FigureTooltip = ({ title, children }: { title: string; children: ReactElement }) => (
  <Tooltip
    title={title}
    arrow
    describeChild
    enterDelay={200}
    slotProps={{ tooltip: { sx: { maxWidth: 260, lineHeight: 1.45 } } }}
  >
    {children}
  </Tooltip>
);
